import { hasDataPage } from "../core/dom";

export function initHomePage() {
    if (!hasDataPage("home")) return;

    console.log("Home page initialized.");
}